import apivendas from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apivendas.get('venda', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async resumoformas(_, { where } = {}) {
      const [{ data }] = await Promise.all([
        apivendas.get('formapagtovenda/resumoformas', { params: where }),
      ]);
      return data;
    },

    async resumototal(_, { where }) {
      console.log('resumo where', where, { where });
      const [{ data }] = await Promise.all([
        apivendas.get('formapagtovenda/resumototal', { params: where }),
      ]);
      return data;
    },

    async produtosvendidos(_, { where }) {
      console.log('itens venda where', where, { where });
      const [{ data }] = await Promise.all([
        apivendas.get('itemvenda/produtosvendidos', { params: where }),
      ]);
      return data;
    },

    async totalprodutos(_, { where }) {
      const [{ data }] = await Promise.all([
        apivendas.get('itemvenda/totalprodutos', { params: where }),
      ]);
      return data;
    },

    async detalharvendedor(_, { where }) {
      const [{ data }] = await Promise.all([
        apivendas.get('venda/detalharvendedor', { params: where }),
      ]);
      return data;
    },

    async detalharcliente(_, { where }) {
      const [{ data }] = await Promise.all([
        apivendas.get('venda/detalhar/cliente', { params: where }),
      ]);
      return data;
    },

    async detalhar(_, { where }) {
      console.log('detalhar', where, { where });
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apivendas.get('venda/detalhar', { params: where }),
        apivendas.get('venda/count', { params: where }),
      ]);

      return { data, total };
    },

    async atualizar(_, { where }) {
      // console.log('atualizar', where, { where });
      const [{ data }] = await Promise.all([
        apivendas.get('venda/atualizar', { params: where }),
      ]);

      return data;
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apivendas.get('documentopagar');

      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apivendas.get(`documentopagar/${id}`);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    loading(state, request) {
      state.loading = request ?? false;
    },
  },
};
